// src\themes\mad\elements\Header\HeaderSelecetLanguage.tsx
'use client';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { setCookie, getCookie } from 'cookies-next';
import { usePathname, useRouter } from 'next/navigation';
import { useDictionary } from '@/core/hooks/use-dictionary';
import clsx from 'clsx';
import { cn } from '@/core/lib/utils';
import { Button } from '@/components/ui/button';

const locales = ['fa', 'en', 'ar'] as const;

type Props = {
    className?: string;
};

export default function HeaderSelectLanguage({
    className,
}: Props) {
    const pathname = usePathname();
    const router = useRouter();
    const { dictionary } = useDictionary();

    // استخراج زبان فعلی — خیلی ساده!
    const segments = pathname.split('/').filter(Boolean); // ['', 'en', 'about'] → ['en', 'about']
    const currentLocale = segments[0] && locales.includes(segments[0] as any)
        ? segments[0]
        : getCookie('locale') || 'en';

    const handleLanguageChange = (newLocale: string) => {
        setCookie('locale', newLocale, {
            maxAge: 30 * 24 * 60 * 60,
            path: '/',
        });

        // اگر زبان فعلی وجود داشت، جایگزینش کن، иначе اضافه کن
        const restOfPath = segments[0] && locales.includes(segments[0] as any)
            ? segments.slice(1)
            : segments;

        const newPath = restOfPath.length > 0
            ? `/${newLocale}/${restOfPath.join('/')}`
            : `/${newLocale}`;

        router.push(`${newPath}${window.location.search}`);
    };


    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button
                    variant="ghost"
                    size="icon"
                    className={cn(
                        "rounded-full backdrop-blur-md transition-all duration-300",
                        className
                    )}
                >
                    <span className="text-sm uppercase">{currentLocale}</span>
                </Button>
            </DropdownMenuTrigger>

            <DropdownMenuContent align="end" className="min-w-36">
                {locales.map((key) => (
                    <DropdownMenuItem
                        key={key}
                        onClick={() => handleLanguageChange(key)}
                        className={clsx(
                            'flex items-center justify-between',
                            currentLocale === key && 'bg-neutral-100 font-medium'
                        )}
                    >
                        <span>{dictionary.ui?.language[key]}</span>
                        <span className="text-xs text-neutral-500 font-mono">
                            {key.toUpperCase()}
                        </span>
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}